module.exports = __webpack_public_path__ + "img/精研课程.52fc3f41.png";